/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { AppRedirect } from '../AppRedirect';

import type { AppRouteItem } from '../../../../stores/router';

export const AppRouterItem = (parentPath: string) => (
    ({ path, component: Component, items, redirectTo, index: indexRoute, hidden }: AppRouteItem, index: number) => {
        const currentLevelPath = `${parentPath}${path ? `/${path}` : ''}`;

        if (hidden) {
            return null;
        }

        if (items && items.length > 0 && Component) {
            return (
                <Route
                    key={`${currentLevelPath}-${index}`}
                    path={`${path}/*`}
                    element={<Component currentPath={currentLevelPath} items={items} />}
                >
                    {items.map(AppRouterItem(currentLevelPath))}

                    {items[items.length - 1].path !== '*' && (
                        <Route
                            key={`${currentLevelPath}-lastPath`}
                            path={'*'}
                            element={<AppRedirect currentLevelPath={currentLevelPath} redirectTo={items[0].path} />}
                        />
                    )}
                </Route>
            );
        } else if (redirectTo) {
            return (
                <Route
                    key={`${path}-${index}`}
                    path={path}
                    element={<Navigate replace to={redirectTo} />}
                />
            );
        } else if (Component) {
            return (
                <Route
                    key={`${currentLevelPath}`}
                    path={path}
                    index={indexRoute}
                    element={<Component currentPath={currentLevelPath} />}
                />
            );
        }

        throw Error('Unexpected route');
    }
);
